import React from 'react';

import AIChatsForm from './ai-chats/AIChatsForm';
import AIMediaForm from './ai-media/AIMediaForm';
import AIAssistantsFrom from './ai-assistants/AIAssistantsFrom';

function CompanyAiFeatures() {
  return (
    <>
      <AIAssistantsFrom />
      <AIChatsForm />
      <AIMediaForm />
    </>
  );
}

export default CompanyAiFeatures;
